<template>
<div class="info">
  <strong class="is-primary">{{ info }}</strong>
  <span class="is-black"><a class="is-black">{{ title }}</a></span>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    info: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.is-primary {
  color: $primary;
  font-weight: bold;
  &:hover {
    text-decoration: none;
  }
}
.is-white {
  color: white;
  font-size: 0.75rem;
}

.is-black {
  color: black;
  font-size: 0.75rem;
}

strong {
  display: inline-block;
  margin-bottom: 0.25rem;
  &:hover {
    text-decoration: none;
  }
}

strong:hover {
  text-decoration: none;
}

span {
  display: block;
}

.info {
  line-height: 1;
  &:hover {
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar-info.vue